import React, { useState, useEffect } from 'react';
import styled from 'styled-components'
import history from '../history'
// import NavBar from '../Components/NavBar';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@material-ui/icons/VisibilityOffOutlined';
import apiM from '../GlobalEnv'

const INPUT = styled.input`
@media screen and (min-width: 47.5rem) {
    font-size: larger;
    &:focus {
        border: #261431;
        border-bottom: 2px solid #261431;
        transition: ease-in-out 2s;
        border-radius: 3rem; 
        outline: none;
      
    }
}
@media screen and (max-width: 47.5rem) {
    & ~ label {
        margin-top: 3rem;
    } 
    font-size: large;
    align-self: center;
    margin: 0rem auto;
    &:focus {
        border: #261431;
        border-bottom: 2px solid #261431;
        transition: ease-in-out 2s;
        border-radius: 3rem; 
        outline: none;
        
      
    }
}
display: block;
margin-top: 1rem;
padding: 1.2rem;
width: 70%;
border-top-color: transparent;
border-right-color: transparent;
border-left-color: transparent;
outline: none;
transition: ease-in-out 1.5s;
align-self: center;


`

const BUTTON = styled.button`
padding: .5rem;
    font-size: large;
    border-radius: 3rem;
    width: 70%;
    font-weight: bold;
    color: white;
    outline: none;
    border: none;
    background: #261431;
    -webkit-letter-spacing: .1rem;
    -moz-letter-spacing: .1rem;
    -ms-letter-spacing: .1rem;
    letter-spacing: .1rem;
    cursor: pointer;
    -webkit-transition: ease-in-out 1.1s;
    transition: ease-in-out 1.1s;
    -webkit-align-self: center;
    -ms-flex-item-align: center;
    align-self: center;
    justify-self: center;
    margin-right: 5rem;
    @media screen and (max-width: 48rem) {
        margin-right: 0rem;
    }
&:hover {
    color: black;
    border: 2px solid #261431;
    background: white; 
    transition: ease-in-out 1s;
}
@media screen and (min-width: 48rem) {
    width: 35%;
}
`

const SUB = styled.section`
 
display: flex;
  flex-flow: column;
   justify-content: center;
 align-items: center;
position: absolute;
background: white;
width: 45rem;
height: auto;
border-radius: 20px;
padding-top: 2rem;
padding-bottom: 2rem;
box-shadow: 1px 3px 7px 2px #545454;
@media screen and(max-width: 48rem) {
   
    display: flex;
  
    flex-flow: column;
 
    justify-content: center;
 
    align-items: center;
    position: absolute;
    background: white;
    width: 100vw;
    height: 100vh;
      padding-bottom: 2rem;
    box-shadow: 1px 3px 7px 2px #545454;
 }


`

const CONTAINER = styled.section`
background: url("https://i.pinimg.com/originals/cc/c3/57/ccc35763ff03668050dabd98ffd9d35b.jpg");
background-repeat: no-repeat;
background-size: cover;
position: relative;
height: 100vh;
width: 100vw;
display: flex;
justify-content: center;
align-items: center;
`
const Login = () => {
    const[email, setE] = useState('')

    const[pass, setPas] = useState('')

    const[cpass, setCPass] = useState('')

    const[err, setErr] = useState('')

    const[show, setShow] = useState(false)
    const[Icon, setIcon] = useState(false)
    const[Type, setType] = useState('password')
    
        const handleShowPass = () => {
                setIcon(!Icon)
                if(Type === 'password') {setType('text')} else setType('password')
            }
    useEffect(() => { document.title = 'Account setup'})

    const handleSubmit = async () => {
        
         try {
            if(cpass !== pass){
                setErr('password did not match')
            }
            
            if(pass !== '' && cpass === pass){
                
                setShow(true)
             setErr('')
             const api = apiM + `/login/newUser/${localStorage.getItem('ref')}`
             
             let data = {
                email: sessionStorage.getItem('mail') ? sessionStorage.getItem('mail'): email,
                password: pass
             }

             let init = {
                     method:'post', 
                     body:JSON.stringify(data), 
                     'headers':{'content-type':'application/json'},
                     mode:'cors'
                 }
           
                 let res = fetch(api, init)

             let ans = await res

             let mAns = await ans.json()
             let {success, lStr, error} = mAns
            //  console.log(await ans.json())
                    // console.log(error)
             if(success === 'account Success') {
                //  console.log(lStr)
                 if(lStr !== '') sessionStorage.setItem('lStr',lStr)
                
                // sessionStorage.setItem('mail', email)
                // localStorage.setItem('mail', email)
                //  sessionStorage.setItem('mail', email)
                
                localStorage.removeItem('ref')
               
                sessionStorage.removeItem('ref') //remove ref from session also
                // console.log('about to push')
            setTimeout(() => history.push(`/dashboard`), 1000);
             }
            if(error) throw error
            } 
            
        }
         catch (error) {
             setShow(false)
             alert(error)
            // console.log(error)
        }
       
    }
    return ( 
        <>
        {/* <NavBar
 fNav={'How To'} 
fNavL='#howWealthme' 
sNav='Home' 
sNavL='/' /> */}
<CONTAINER>
 <SUB>

       <h2 id="dashH" style={{textAlign:'center', marginBottom:'3rem'}}>Iamwealthy</h2>

       <form onSubmit={e => e.preventDefault()} >

<label htmlFor='email'><strong>Email:</strong></label>
               <INPUT 
                 autoComplete='true'
                type='email' 
                style={{lineHeight: '1.5rem'}}
                placeholder='myemail@gmail.com'
                required={true}
                onChange={({target}) => setE(target.value)}
                value={sessionStorage.getItem('mail') ? sessionStorage.getItem('mail'): email }
                 
                 />
                 <br />

<label htmlFor='text'><strong>Password:</strong></label>
<span style={{display:'flex'}}>

               <INPUT 
                 autoComplete='true'
                type={Type} 
                style={{lineHeight: '1.5rem'}}
                placeholder='password'
                required={true}
                autoFocus  
                onChange={({target}) => setPas(target.value)}
                 
                 />
                 <span onClick={handleShowPass} style={{alignSelf:'center', marginLeft:'1rem'}}>{Icon ? <VisibilityOutlinedIcon /> : <VisibilityOffOutlinedIcon /> }</span>
                 </span>
                 <br />

<label htmlFor='Password'><strong>Confirm Passord:</strong></label>
               <INPUT 
                autoComplete='true'
                type='password' 
                style={{lineHeight: '1.5rem'}}
                placeholder='confirm password'
                required={true}
                onChange={({target}) => setCPass(target.value)}
 
                 />
                 <small style={{color:'red'}}>{err} </small>
                 <br />
                 <br />
 
 

       </form>
 <BUTTON type='submit' onClick={handleSubmit} style={show === true ? {display:'none'} : {display:'block'}}>Submit </BUTTON>
 

 <img src={require('../Assets/Preloaders/25.gif')} alt='confirming payment' style={show === false ? {display:'none'}: {display:'block', height: '3rem', width:'3rem'}} />  
 

   </SUB>
</CONTAINER>

        </>
     );
}
 
export default Login;